import takeRequest from '~/store/takeRequest';
import { getHiscon } from './actions';

export function* hisconSaga() {
  yield takeRequest(getHiscon);
}
